import Timeout from './Timeout.svelte';

const timeout = new Timeout({
	target: document.querySelector("timeout"),
	props: {
		name: 'world'
	}
});

export default timeout;